import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { ItemSelectorState } from '../../helpers/types';

@Component({
  selector: 'app-selected-items',
  templateUrl: './selected-items.component.html',
  styles: [
    `
      .selected {
        color: #0f6ecd;
        font-weight: bold;
      }
    `
  ]
})
export class SelectedItemsComponent {
  @Input() state: Observable<ItemSelectorState>;
  @Input() component: string;
}
